<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/catchmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="handleExport"
      buttonType="warning"
      buttonName="导出"
      addShowPower="/catchmanage/withDrawExport"
      :showDownloadPower="true"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      downloadPower="/catchmanage/qpayInfoQry"
      @down="down"
    >
      <el-form-item label="代理商/商户ID">
        <el-input
          v-model="formModel.memId"
          placeholder="请输入代理商/商户ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商姓名">
        <el-input
          v-model="formModel.memName"
          placeholder="请输入代理商姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商电话">
        <el-input
          v-model="formModel.memPhone"
          placeholder="请输入代理商电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="银行卡号">
        <el-input
          v-model="formModel.cardNo"
          maxlength="50"
          placeholder="请输入银行卡号"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账户类型" prop="accountType">
        <el-select v-model="formModel.accountType">
          <el-option
            v-for="item in accountType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="转账类型" prop="withdrawType">
        <el-select v-model="formModel.withdrawType">
          <el-option
            v-for="item in withdrawType"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
         <el-form-item label="机构名称" prop="activityName" v-if="this.textTatSimpleId">
         <el-select style="width: 198px" v-model="formModel.tatSimpleId" filterable>
                    <el-option
                        v-for="item in typeTwo"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
        <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="memId"
        label="代理商/商户ID"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="代理商姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="代理商电话"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="accountType"
        label="账户类型"
        min-width="150"
        :formatter="formatterTableacctType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="reqNo"
        label="订单号"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="到账金额（元）"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.amount * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <!-- 新增 -->
         <el-table-column
        prop="srcAmout"
        label="提现金额（元）"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.srcAmout * 100) / 10000) }}</p>
        </template>
      </el-table-column>

      <!-- 新增 -->
         <el-table-column
        prop="tatAmout"
        label="机构利润（元）"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.tatAmout * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="bankName"
        label="到账银行"
        min-width="100"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="bankNo"
        label="银行卡号"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="交易状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.status == 0">已发送</p>
          <p v-else-if="scope.row.status == 1">交易成功</p>
          <p v-else-if="scope.row.status == 3">待审核</p>
          <p v-else-if="scope.row.status == 4">处理中</p>
          <p v-else>交易失败</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawType"
        label="转账类型"
        :formatter="formatterTableDatawithdrawType"
        min-width="150"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="errMsg"
        label="响应信息"
        min-width="280"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="交易时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>提现金额：{{ toDoubleThousands(dialogAmount) }}元</p>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import LYFAcctTypes from "service/constant/LYFAcctTypes";

import FinanceService from "service/FinanceService";
import OrganService from "service/OrganService";
import TimeRange from "service/constant/TimeRange";
import StatisticsService from "service/StatisticsService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import activity from "service/Ainstitution";
export default {
  name: "catchmanage",
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
  },
  data() {
    return {
      formModel: {
        memId: "",
        memName: "",
        memPhone: "",
        cardNo: "",
        status: "",
        withdrawType: "",
        accountType: "",
        tatSimpleId: '',
      },
      submitService: FinanceService.getWithdraws,
      page: {},
      dialogAmount: 0,
      time: TimeRange.dayRange,
      typeTwo: [{ tatName: "全部", id: "" }],
      status: [
        {
          id: "",
          label: "全部",
        },
        {
          id: "0",
          label: "已发送",
        },
        {
          id: "1",
          label: "交易成功",
        },
        {
          id: "2",
          label: "交易失败",
        },
        {
          id: "3",
          label: "待审核",
        },
        {
          id: "4",
          label: "处理中",
        },
      ],
      withdrawType: [
        {
          id: "",
          value: "全部",
        },

        {
          id: "1",
          value: "线上转账",
        },
        {
          id: "2",
          value: "线下转账",
        },
      ],
      accountType: LYFAcctTypes,
      tableData: [],
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
     this.getTypeTwo()
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      const params = {
        userId: this.userId,
        memId: this.formModel.memId,
        memName: this.formModel.memName.trim(),
        memPhone: this.formModel.memPhone.trim(),
        cardNo: this.formModel.cardNo.trim(),
        status: this.formModel.status,
        withdrawType: this.formModel.withdrawType,
        accountType: this.formModel.accountType,
        tatSimpleId: this.formModel.tatSimpleId,
        startDate: this.time[0],
        endDate: this.time[1],
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.time.length == 0) {
        delete params.startDate;
        delete params.endDate;
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId","textTatSimpleId"]),
  },
  methods: {
     getTypeTwo() {
        this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows,'res1')
            res.contents.rows.forEach(item => {
              item.dictValue = item.id,
              item.dictKey = item.tatName
            })
            this.typeTwo = [...this.typeTwo,...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    down() {
      this.doLoad(
        StatisticsService.statisWithdraws,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogAmount = 0;
            if (result) {
              this.dialogAmount = result.amount;
            }
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    handleExport() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "",
            "/withdrawrecord/"
          )
        : "";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getWithdraws,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    formatterTableDatawithdrawType(row, column, cellValue, index) {
      let value = "--";
      this.withdrawType.forEach((item) => {
        if (item.id == cellValue) {
          value = item.value;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/CatchManage.vue